
















import { Vue, Component, Prop } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import NoAuth from '../comps/no-auth.vue'
import * as utils from '@ivy/fts/utils'
import { requireGet } from '../require'
@Component({
  components: {
    NoAuth,
  },
})
export default class Index extends Vue {
  activityId: any = ''
  hasLogined: boolean = false
  showToast: boolean = false
  landing_bg: any = ''
  ivy_logo: any = require('../imgs/ivydad-logo.png')
  landing_bg_color: any = ''
  hasAuth: boolean = false
  async created() {
    await env.init()
    this.activityId = this.$route.query.activityId
    if (!this.activityId) {
      return this.$Toast('问卷不存在～')
    }
    await this.getInfo()
  }
  async getInfo() {
    const { data: authInfo } = await requireGet(
      `/api/activity/appActivity/typeTestActivity/checkAuth?activity_id=${
        this.$route.query.activityId
      }`
    )
    if (authInfo.CODE) {
      return this.$Toast(authInfo.message)
    }
    this.hasAuth = authInfo.is_auth
    this.landing_bg =
      authInfo.activity &&
      authInfo.activity.activity_info &&
      authInfo.activity.activity_info.bg_pic
    this.landing_bg_color =
      authInfo.activity &&
      authInfo.activity.activity_info &&
      authInfo.activity.activity_info.bg_color
  }
  async startTest() {
    // 判断是否登录 调用登录
    await this.isLogined()
    if (!this.hasLogined) return
    // 判断是否有指定课程权限
    await this.getInfo()
    if (!this.hasAuth) {
      this.showToast = true
      await utils.sleep(1500)
      this.showToast = false
      return
    } else {
      this.$router.push({
        path: '/questionnaire/testPage',
        query: {
          activityId: this.activityId,
        },
      })
    }
  }
  async isLogined() {
    let isLogin = await env.getIsLogin()
    this.hasLogined = isLogin
    if (!isLogin) {
      return await env.login()
    }
  }
}
